import {
  arcaneWhisper,
  steelClash,
  royalSeal,
  victoryChime,
  shadowDenial,
  vaultEcho,
  clanBanner,
  amethystCall,
} from '../assets';

type SoundConfig = {
  src: string;
  volume?: number;
};

export const sounds = {
  arcaneWhisper: {
    src: arcaneWhisper,
    volume: 0.15,
  },

  steelClash: {
    src: steelClash,
    volume: 0.35,
  },

  royalSeal: {
    src: royalSeal,
    volume: 0.25,
  },

  victoryChime: {
    src: victoryChime,
    volume: 0.3,
  },

  shadowDenial: {
    src: shadowDenial,
    volume: 0.2,
  },

  vaultEcho: {
    src: vaultEcho,
    volume: 0.22,
  },

  clanBanner: {
    src: clanBanner,
    volume: 0.28,
  },

  amethystCall: {
    src: amethystCall,
    volume: 0.25,
  },
} as const satisfies Record<string, SoundConfig>;

export type SoundType = keyof typeof sounds;
